import React from 'react';
import { arrayOf, bool, number, object, shape, string } from 'prop-types';
import ProfileImage from '@fiverr-private/profile_image/src/ProfileImage';
import { getContext } from '@fiverr-private/fiverr_context';
import { getSellerLanguageParams } from '../../../utils/sellerLanguage';
import { BQ_CLICKED_SELLER_LINK } from '../../../utils/bigQueryEvents';
import SellerLanguage from '../../shared/SellerLanguage';
import RatingWrapper from '../../shared/RatingWrapper';
import Status from './Status';
import OneLiner from './OneLiner';
import ContactMe from './ContactMe';

import './style.scss';

const SELLER_LINK_CLASS = 'seller-link';

const ProfileInfo = (props, context) => {
    const { pathfinderWrapper, general } = context;
    const { locale, pathParameters, browserLanguage, countryCode: buyerCountryCode } = getContext();

    const onSellerLinkClick = () => {
        const { biEvents } = context;

        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_SELLER_LINK });
    };

    const { username } = pathParameters;
    const {
        isPro,
        oneLiner,
        ratingsCount,
        rating,
        achievement,
        hasProfilePhoto,
        profilePhoto,
        shouldRenderSellerLanguage,
        countryCode,
        proficientLanguages
    } = props;

    const sellerUrl = pathfinderWrapper.pathfinder('short_user', { id: username });
    const profileImageUserProps = {
        username,
        achievement,
        has_profile_photo: hasProfilePhoto,
        profile_photo: profilePhoto,
        is_pro: isPro,
        is_seller: true
    };
    const { isLimitedEdition } = general;
    const sellerLanguageParams = shouldRenderSellerLanguage ? getSellerLanguageParams({
        buyer: {
            locale,
            browserLanguage,
            countryCode: buyerCountryCode
        },
        seller: {
            proficientLanguages,
            countryCode
        }
    }) : null;

    return (
        <div className="profile-info">
            <ProfileImage user={profileImageUserProps} profileImageSize={110} locale={locale}/>
            <div className="user-profile-label">
                <div className="username-line">
                    {isLimitedEdition ?
                        <span className={SELLER_LINK_CLASS}>{username}</span> :
                        <a href={sellerUrl}
                            className={SELLER_LINK_CLASS}
                            onClick={onSellerLinkClick}>
                            {username}</a>
                    }
                    <Status/>
                </div>
                {(oneLiner || ratingsCount > 0) &&
                    <div className="one-liner-rating-wrapper">
                        {oneLiner && <OneLiner oneLiner={oneLiner}/>}
                        {ratingsCount > 0 &&
                        <RatingWrapper className="seller-rating"
                            rating={rating}
                            ratingsCount={ratingsCount}/>
                        }
                    </div>
                }
                { shouldRenderSellerLanguage &&
                    <div className="seller-language-wrapper">
                        <SellerLanguage sellerLanguages={sellerLanguageParams.sellerValidatedLanguages}
                            commonLanguage={sellerLanguageParams.commonLanguage}/>
                    </div>
                }
                { !isLimitedEdition && <ContactMe/> }
            </div>
        </div>
    );
};

ProfileInfo.propTypes = {
    isPro: bool,
    oneLiner: string,
    ratingsCount: number,
    rating: number,
    achievement: number,
    hasProfilePhoto: bool,
    profilePhoto: string,
    shouldRenderSellerLanguage: bool,
    countryCode: string,
    proficientLanguages: arrayOf(
        shape({
            name: string,
            level: number
        })
    )
};

ProfileInfo.contextTypes = {
    pathfinderWrapper: object,
    general: object,
    biEvents: object
};
export { SELLER_LINK_CLASS };

export default ProfileInfo;
